import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../service';

import { Logger } from '../logger/logger.service';
const log = new Logger('NotificationService');

@Injectable({
  providedIn: 'root'
})

export class McNotificationService {

  // private currentMessage = new BehaviorSubject(null);

  constructor(
    private sdk: MycureSDK,
  ) {

  }

  /**
   * Ask for notification and save device token
   * @param userId 
   */
  async getPermission(userId: string, vapidKey: string) {
    this.sdk.notifications().getDeviceToken$(vapidKey)
      .subscribe(async (token: any) => {
        if (token) {
          // save the token
          const update: any = { $addToSet: { deviceTokens: token } };
          await this.sdk.accounts().update(userId, update);
          log.debug('notification token successfully saved');
        }
      });
  }

  // receiveMessage() {
  //   if (this.messaging) {
  //     this.messaging.onMessage((payload: any) => {
  //       this.currentMessage.next(payload);
  //     });
  //   }
  // }
}
